import { render, staticRenderFns } from "./EmployeesByGender.vue?vue&type=template&id=343c9dc9&scoped=true&"
import script from "./EmployeesByGender.vue?vue&type=script&lang=js&"
export * from "./EmployeesByGender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "343c9dc9",
  null
  
)

export default component.exports